import React from 'react';

const FAQ = () => (
  <div className="container my-5">
    <div className="text-center mb-4">
      <h2 className="fw-bold">Frequently Asked Questions</h2>
      <p className="text-muted">Get answers to the most common questions about PharmaCart</p>
    </div>

    <div className="accordion" id="faqAccordion">
      {/* Question 1 */}
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingOne">
          <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne">
            💊 How do I place an order?
          </button>
        </h2>
        <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#faqAccordion">
          <div className="accordion-body">
            To place an order, simply browse through our product categories, add your items to the cart, and proceed to checkout. You can pay using cards, UPI, or cash on delivery. Prescription may be required for select medicines.
          </div>
        </div>
      </div>

      {/* Question 2 */}
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingTwo">
          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo">
            🚚 How long does delivery take?
          </button>
        </h2>
        <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
          <div className="accordion-body">
            We deliver most orders within 24-48 hours. Delivery times may vary depending on your location, availability of products, and prescription verification.
          </div>
        </div>
      </div>

      {/* Question 3 */}
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingThree">
          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree">
            🔐 Is my information secure?
          </button>
        </h2>
        <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
          <div className="accordion-body">
            Absolutely. We use industry-standard encryption and secure servers to protect your data. Your personal and medical information is never shared with third parties without your consent.
          </div>
        </div>
      </div>

      {/* Question 4 */}
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingFour">
          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour">
            📦 What if a product is unavailable?
          </button>
        </h2>
        <div id="collapseFour" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
          <div className="accordion-body">
            If a product is out of stock, you can choose to get notified when it's available again or speak to our support team for alternatives.
          </div>
        </div>
      </div>

      {/* Question 5 */}
      <div className="accordion-item">
        <h2 className="accordion-header" id="headingFive">
          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive">
            🧾 Can I return or cancel an order?
          </button>
        </h2>
        <div id="collapseFive" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
          <div className="accordion-body">
            Orders can be canceled before dispatch. Returns are only accepted for damaged, expired, or wrongly delivered products. Read our full return policy for details.
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default FAQ;
